export const DEALER_SELECTION_MUTATIONS = {
    SET_ZIP_CODE: 'setZipCode',
    SET_PROJECT_ID: 'setProjectId',
    SET_SELECTED_DEALER: 'setSelectedDealer',
};
